import { Component, OnInit } from '@angular/core';
import { HEC_CONSTANTS } from '../../../../../utilities/constants';

@Component({
  selector: 'kt-downloadresources',
  templateUrl: './downloadresources.component.html',
  styleUrls: ['./downloadresources.component.css']
})
export class DownloadresourcesComponent implements OnInit {
  public manualList: any = HEC_CONSTANTS.MANUAL_LIST;

  constructor() { }

  ngOnInit() {
  }

  public fileType(fileName){
    return fileName.split('.')[1]
  }

  public downloadPageManual(index): void {
    window.open('./assets/manuals/' + this.manualList[index].fileName)

  }

}
